/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/invoiceData.scss';

import {ChangeKeyFunction, voidFunction} from '@dvrd/dvr-controls';
import React, {useMemo} from 'react';
import Invoice from "../../../models/invoiceModel";
import {BolmateInput} from "../../controls";
import CountryField from "../../controls/country/field/countryField";
import useRight from "../../misc/useRight";
import {AccessKey} from "../../../util/interfaces";

interface Props {
    onChange?: ChangeKeyFunction;
    invoice: Invoice;
    disabled?: boolean;
    loading?: boolean;
}

export default function InvoiceData(props: Props) {
    const [canEdit] = useRight(AccessKey.INVOICE_EDIT_CUSTOMER);
    const {loading, onChange, disabled, invoice} = props;
    const fieldsDisabled = disabled || loading || !canEdit;
    const onChangeField = useMemo(() => onChange ?? (() => voidFunction), [onChange]);

    const {
        orderId, company, firstname, lastname, email, street, houseNumber, houseNumberSuffix, zipCode, city,
        reference, cocNumber, vatNumber
    } = invoice;

    return (
        <div className='invoice-data'>
            <label className='col-title'>Factuurgegevens (order {orderId})</label>
            <div className='fields-container'>
                <div className='col'>
                    <BolmateInput onChange={onChangeField('company')} value={company} label='Bedrijf'
                                  disabled={fieldsDisabled}/>
                    <BolmateInput value={firstname} onChange={onChangeField('firstname')} label='Voornaam'
                                  disabled={fieldsDisabled}/>
                    <BolmateInput value={lastname} onChange={onChangeField('lastname')} label='Achternaam'
                                  disabled={fieldsDisabled}/>
                    <BolmateInput value={email} onChange={onChangeField('email')} label='E-mailadres'
                                  disabled={fieldsDisabled} inputProps={{type: 'email'}}/>
                </div>
                <div className='col'>
                    <BolmateInput value={street} onChange={onChangeField('street')} label='Adres'
                                  disabled={fieldsDisabled}/>
                    <div className='row'>
                        <BolmateInput value={houseNumber} onChange={onChangeField('house_number')}
                                      label='Huisnummer' disabled={fieldsDisabled}/>
                        <BolmateInput value={houseNumberSuffix} onChange={onChangeField('house_number_suffix')}
                                      label='Toevoeging' disabled={fieldsDisabled} className='suffix'/>
                    </div>
                    <BolmateInput value={zipCode} onChange={onChangeField('zip_code')} label='Postcode'
                                  disabled={fieldsDisabled}/>
                    <BolmateInput value={city} onChange={onChangeField('city')} label='Stad'
                                  disabled={fieldsDisabled}/>
                    <CountryField onChange={onChangeField('country')} disabled={fieldsDisabled}
                                  value={invoice.countryName} labelAsValue/>
                </div>
                <div className='col'>
                    <BolmateInput value={reference} onChange={onChangeField('reference')} label='Referentie'
                                  disabled={fieldsDisabled}/>
                    <BolmateInput value={cocNumber} onChange={onChangeField('coc_number')} label='KvK-nummer'
                                  disabled={loading} inputProps={{placeholder: 'KvK nummer'}}/>
                    <BolmateInput value={vatNumber} onChange={onChangeField('vat_number')} label='BTW-nummer'
                                  disabled={loading} inputProps={{placeholder: 'BTW nummer'}}/>
                </div>
            </div>
        </div>
    )
}